// import { callPhone } from '../libs/native-app';

const mixin = {
  data() {
    return {};
  },
  methods: {
    go(path) {
      this.$router.push(path);
    },
    laterGo(path, replace) {
      setTimeout(() => {
        replace ? this.$router.replace(path) : this.$router.push(path);
      }, 1500);
    },
    goBack() {
      this.$router.go(-1);
    },
    laterGoBack() {
      setTimeout(() => {
        this.goBack();
      }, 1000);
    },
    $warning(message) {
      this.$toast(message);
    },
    $error(message) {
      this.$toast(message);
    },
    $success(message) {
      this.$toast.success(message);
    },
    $loading(message, duration) {
      this.$toast.loading({
        duration: duration || 0,
        forbidClick: true,
        loadingType: 'spinner',
        message: message || '请稍后'
      });
    },
    $loadingClose() {
      this.$toast.clear();
    },
    callTel(mobile) {
      // callPhone({ phone: mobile });
      window.location.href = `tel:${ mobile }`;
    },
    turnToDownload() {
      if (window.location.href.indexOf('dswldapp.dasheng78.cn') >= 0) {
        window.location.href = 'https://myunonline-qiangban.oss-cn-hangzhou.aliyuncs.com/download-app/dswp-down-zs.html?opentype=brower'; // 正式
      } else if (window.location.href.indexOf('wldapptest.myun.info') >= 0) {
        window.location.href = 'https://www.pgyer.com/x2vM?opentype=brower'; // 测试
      } else if (window.location.href.indexOf('dsqbwld-check.dasheng78.cn') >= 0) {
        window.location.href = 'https://myunonline-qiangban.oss-cn-hangzhou.aliyuncs.com/download-app/dswp-down-ys.html?opentype=brower'; // 验收
      } else {
        window.location.href = 'https://myunonline-qiangban.oss-cn-hangzhou.aliyuncs.com/download-app/dswp-down-zs.html?opentype=brower'; // 正式
      }
    }
  },
  filters: {
    formatMoney: function (value = 0, len = 2) {
      return value ? value.toFixed(len) : value;
    },
    formatFixed2: function (value = 0) {
      return Math.round(value * 100) / 100;
    }
  }
};

export default mixin;
